import React from 'react'
import { Card, CardContent, Typography, Box, Chip } from '@mui/material'

const formatDate = dateString => {
  // Parse date as local time to avoid timezone conversion issues
  // dateString format: "2026-07-14"
  const [year, month, day] = dateString.split('-').map(Number)
  const date = new Date(year, month - 1, day) // month is 0-indexed
  const dayOfWeek = date.toLocaleString('default', { weekday: 'short' })
  const monthName = date.toLocaleString('default', { month: 'short' })
  return `${dayOfWeek}, ${monthName} ${day}`
}

const DayCard = ({ day, isSelected = false, isReserved = false, onToggle }) => {
  const { title, date, dayNumber, soldOut, remainingCapacity } = day
  const formattedDate = formatDate(date)
  const isDisabled = soldOut || isReserved

  return (
    <Card
      sx={{
        height: '100%',
        border: isSelected ? 2 : isReserved ? 2 : 1,
        borderColor: isSelected
          ? 'primary.main'
          : isReserved
            ? 'success.main'
            : 'grey.300',
        opacity: isDisabled ? 0.6 : 1,
        cursor: isDisabled ? 'default' : 'pointer',
        backgroundColor: isReserved ? 'success.50' : 'background.paper',
        '&:hover': isDisabled
          ? {}
          : {
              borderColor: 'primary.main',
              boxShadow: 2
            }
      }}
      onClick={isDisabled ? undefined : onToggle}
    >
      <CardContent>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='flex-start'
          mb={1}
        >
          <Typography
            variant='caption'
            color='text.secondary'
            fontWeight='medium'
          >
            Day {dayNumber}
          </Typography>
          {isReserved && (
            <Chip
              label='Reserved'
              size='small'
              color='success'
              sx={{ height: 20, fontSize: '0.65rem' }}
            />
          )}
          {isSelected && !isReserved && (
            <Chip
              label='Selected'
              size='small'
              color='primary'
              sx={{ height: 20, fontSize: '0.65rem' }}
            />
          )}
          {soldOut && !isReserved && !isSelected && (
            <Chip
              label='Sold Out'
              size='small'
              color='error'
              sx={{ height: 20, fontSize: '0.65rem' }}
            />
          )}
        </Box>

        <Typography variant='subtitle2' fontWeight='bold' gutterBottom>
          {title}
        </Typography>

        <Typography variant='caption' color='text.secondary' display='block'>
          {formattedDate}
        </Typography>

        {!soldOut && remainingCapacity !== undefined && (
          <Typography
            variant='caption'
            color={remainingCapacity < 5 ? 'warning.main' : 'text.secondary'}
            display='block'
            mt={0.5}
          >
            {remainingCapacity} spots left
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export default DayCard
